let baseurl=window['apiUrl'];

export const gfUrl = async (url) => {
  let fUrl = `${baseurl}/${url}`;
  return fUrl;
}
export const loaderPostFetch = async (url, data) => {
  //let fUrl=`${window.API}/${url}`;
  let fUrl = `${baseurl}/${url}`; 
  return new Promise(async (y, n) => {
    try {
      const response = await fetch(fUrl, {
        method: 'POST',
        body: data,
      });
      const movies = await response.json();
      y(movies);
      //console.log('Download complete', response);
    } catch (error) {
      //console.error(`Download error: ${error.message}`);
      y();
    }
  });
};

export const csAmount = (n) => {
  return new Intl.NumberFormat('en', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    //minimumSignificantDigits: 2,
  }).format(n);
};
